import React, { Component } from "react";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import "./HomeHero.scss";
import hero1 from "../../assets/hero-1.jpg";
import hero2 from "../../assets/hero-2.jpg";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    />
  );
}

export default class HomeHero extends Component {
  render() {
    const {data} = this.props;
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />, 
      prevArrow: <SamplePrevArrow />,
      autoplay: true, 
      speed: 3000,
      autoplaySpeed: 3000,
      pauseOnHover: true
    };
    return (
      <div className="home-hero-slider">
        <Slider {...settings}>
          {data?.map(slide => 
          <div className="slide-holder" key={slide.id}>
            <img src={slide.image} alt="" />
            <div className="content container">
              <h3>{slide.name}</h3>
              <h4>up to 40 %</h4>
            </div>
          </div>
            )}
        </Slider>
      </div>
    );
  }
}
